/**
 * LigaMagic (Brazil) links. NOT an affiliate link (plan 2026-10-04, section
 * 2). The per-card link is the store's card page for the English name exactly
 * as the deck spells it; phase 0 checked Sol Ring, Rhystic Study, Fable of the
 * Mirror-Breaker and Fire // Ice.
 */

const LIGAMAGIC_CARD = 'https://www.ligamagic.com.br/?view=cards/card&card='

/** The list-import page (phase 0, Keith 2026-10-04): the "Compra por Lista"
 *  tool, limited to 110 cards per search. */
export const LIGAMAGIC_LIST_URL = 'https://www.ligamagic.com.br/?view=cards/lista'

export function ligamagicCardUrl(cardName: string): string {
  return LIGAMAGIC_CARD + encodeURIComponent(cardName.trim())
}
